var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "grid gap-[2px]",
    style: {
      gridTemplateColumns: 'repeat(' + _vm.shape[0].length + ', ' + _vm.size + 'px)',
      gridTemplateRows: 'repeat(' + _vm.shape.length + ', ' + _vm.size + 'px)'
    }
  }, _vm._l(_vm.flatShape, function (item) {
    return _c('div', {
      key: item.r + '-' + item.c,
      staticClass: "w-full h-full rounded-[2px]",
      class: item.cell ? _vm.COLOR_MAP[_vm.color] : 'bg-transparent'
    });
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };